<template>
  <div class="card h-100 mb-0">
    <div class="card-body d-flex justify-content-between align-items-start">
      <div>
        <p class="text-muted mb-2">{{ title }}</p>
        <b-spinner v-if="loading" small variant="info" />
        <template v-else-if="error">
          <small class="text-danger d-block mb-2">{{
            $t("label.dashboardLoadError")
          }}</small>
          <b-button size="sm" variant="outline-info" @click="$emit('retry')">{{
            $t("label.retryPermissionDefinitions")
          }}</b-button>
        </template>
        <h3 v-else class="mb-0">{{ value }}</h3>
        <small v-if="subtitle" class="text-muted">{{ subtitle }}</small>
      </div>
      <i :class="['mdi', icon, 'font-size-24', 'text-info']"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "DashboardStatisticCard",
  props: {
    title: { type: String, required: true },
    value: { type: [Number, String], default: 0 },
    icon: { type: String, default: "mdi-chart-box-outline" },
    subtitle: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },
};
</script>
